export default function trackingEvents(
  eventCategory: string,
  eventName: string,
  functionName: string,
  text: string
) {
  GustoAnalytics.track({
    eventCategory,
    eventName,
    data: {
      function: functionName,
      text,
    },
  });
}
